@for(item of actionButtons; track item; let i = $index){
    <button [class]="item.buttonClass"(click)="onUserAction(item.userAction);" [class]="item.buttonClass" [ngClass]="{'disabled-state': item.disableProperty }" >
        <img [src] = "item.buttonIcon" alt="">
    </button>
}

<!-- @for(item of actionButtons; track item; let i = $index){<div>
    {{ item.textBeforeBtn }}
    @if(!item.hideProperty){<ds-button [buttonInput]="buttonConfig[i]"
        (onClick)="onUserAction(item.userAction)"></ds-button>}
</div>} -->